///////////////////////////////////////////////////////////////////////////////
// Copyright (C) 2002-2023, Open Design Alliance (the "Alliance").
// All rights reserved.
//
// This software and its documentation and related materials are owned by
// the Alliance. The software may only be incorporated into application
// programs owned by members of the Alliance, subject to a signed
// Membership Agreement and Supplemental Software License Agreement with the
// Alliance. The structure and organization of this software are the valuable
// trade secrets of the Alliance and its suppliers. The software is also
// protected by copyright law and international treaty provisions. Application
// programs incorporating this software must include the following statement
// with their copyright notices:
//
//   This application incorporates Open Design Alliance software pursuant to a
//   license agreement with Open Design Alliance.
//   Open Design Alliance Copyright (C) 2002-2021 by Open Design Alliance.
//   All rights reserved.
//
// By use of this software, its documentation or related materials, you
// acknowledge and accept the above terms.
///////////////////////////////////////////////////////////////////////////////

import * as ODA from "open-cloud-client";
import * as THREE from "three";
import { OrbitControls } from "three/examples/jsm/controls/OrbitControls.js";
import type { ThreejsViewer } from "../ThreejsViewer";

export class OrbitDragger extends OrbitControls {
  private viewer: ThreejsViewer;

  constructor(viewer: ThreejsViewer) {
    super(viewer.camera, viewer.canvas);
    this.mouseButtons = { LEFT: THREE.MOUSE.ROTATE, MIDDLE: THREE.MOUSE.PAN, RIGHT: THREE.MOUSE.PAN };
    this.touches = { ONE: THREE.TOUCH.ROTATE, TWO: THREE.TOUCH.DOLLY_PAN };
    this.screenSpacePanning = true;
    this.rotateSpeed = 0.33;
    this.viewer = viewer;
    this.viewer.addEventListener("geometryend", this.geometryEnd);
    this.addEventListener("change", this.updateViewer);
  }

  override dispose() {
    this.removeEventListener("change", this.updateViewer);
    this.viewer.removeEventListener("geometryend", this.geometryEnd);
    super.dispose();
  }

  geometryEnd = (event: ODA.GeometryEndEvent) => {
    const { data: scene } = event;
    const box = new THREE.Box3().setFromObject(scene);
    const size = box.getSize(new THREE.Vector3()).length();

    this.maxDistance = size * 10;
    this.update();
  };

  updateViewer = () => {
    this.viewer.update();
  };
}
